import { motion } from "framer-motion";

export function PageHeader({ title, subtitle, icon: Icon, actions }) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-bold text-slate-800 sm:text-3xl">
          {Icon && <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-blue-50 text-blue-500"><Icon className="h-5 w-5" /></span>}
          {title}
        </h1>
        {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, tint = "blue", hint, onClick, testid }) {
  const tints = {
    blue: "bg-blue-50 text-blue-500", purple: "bg-purple-50 text-purple-500",
    emerald: "bg-emerald-50 text-emerald-500", amber: "bg-amber-50 text-amber-500",
    rose: "bg-rose-50 text-rose-500", sky: "bg-sky-50 text-sky-500", indigo: "bg-indigo-50 text-indigo-500",
  };
  return (
    <motion.button whileHover={{ y: -4 }} onClick={onClick} data-testid={testid}
      className="card-soft card-hover flex w-full items-center gap-3 p-4 text-left">
      {Icon && <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${tints[tint]}`}><Icon className="h-5 w-5" /></span>}
      <div className="min-w-0">
        <div className="text-2xl font-bold leading-6 text-slate-800">{value}</div>
        <div className="text-xs leading-tight text-slate-500 break-words">{label}</div>
        {hint && <div className="text-[11px] text-slate-400">{hint}</div>}
      </div>
    </motion.button>
  );
}

export function SectionCard({ title, action, children, className = "", testid }) {
  return (
    <div className={`card-soft p-5 ${className}`} data-testid={testid}>
      {(title || action) && (
        <div className="mb-4 flex items-center justify-between">
          {title && <h3 className="font-brand text-base font-semibold text-slate-800">{title}</h3>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

const STATUS_COLORS = {
  active: "bg-emerald-50 text-emerald-600 border-emerald-200",
  confirmed: "bg-emerald-50 text-emerald-600 border-emerald-200",
  paid: "bg-emerald-50 text-emerald-600 border-emerald-200",
  completed: "bg-emerald-50 text-emerald-600 border-emerald-200",
  accepted: "bg-emerald-50 text-emerald-600 border-emerald-200",
  delivered: "bg-emerald-50 text-emerald-600 border-emerald-200",
  new: "bg-blue-50 text-blue-600 border-blue-200",
  in_progress: "bg-sky-50 text-sky-600 border-sky-200",
  quoted: "bg-purple-50 text-purple-600 border-purple-200",
  sent: "bg-purple-50 text-purple-600 border-purple-200",
  follow_up: "bg-amber-50 text-amber-600 border-amber-200",
  pending: "bg-amber-50 text-amber-600 border-amber-200",
  due: "bg-amber-50 text-amber-600 border-amber-200",
  overdue: "bg-rose-50 text-rose-600 border-rose-200",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
  in_transit: "bg-sky-50 text-sky-600 border-sky-200",
  shipped: "bg-sky-50 text-sky-600 border-sky-200",
};

export function StatusPill({ status }) {
  if (!status) return null;
  const key = String(status).toLowerCase().replace(/\s+/g, "_");
  const cls = STATUS_COLORS[key] || "bg-slate-50 text-slate-600 border-slate-200";
  return <span className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-medium capitalize ${cls}`}>{String(status).replace(/_/g, " ")}</span>;
}
